<template lang="pug">
.wrap
  page-title Create a new brief

  brief-form(v-model='brief' @save='onSave' :create-another='createAnother' ref='form')
    template(slot='saveOptions')
      el-checkbox(v-model='createAnother') Save and create another

</template>

<script>
import { mapGetters, mapActions } from "vuex";

import PageTitle from "@/shared/components/layout/PageTitle";
import BriefForm from "@/brapp/components/sections/briefs/BriefForm";

const getInitialBriefData = () => {
  return {
    title: "",
    content: "",
    type: "one-off",
    status: "draft",
    startDatetime: null,
    endDatetime: null,
    recurringStartDate: null,
    recurringEndDate: null,
    timezone: "",
    assignees: [],
    questions: [],
    days: [],
    startTime: null,
    endTime: null
  };
};

export default {
  components: { PageTitle, BriefForm },
  inject: ["mainPane"],
  data() {
    return {
      loading: false,
      createAnother: false,
      brief: getInitialBriefData()
    };
  },
  // watch: {
  //   '$route.query.createAnother': (newVal) => {
  //     this.createAnother = newVal
  //   }
  // },
  computed: {
    ...mapGetters("auth", ["activeCompany"])
  },
  methods: {
    ...mapActions("briefs", ["createBrief"]),
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      const newBriefData = {
        ...this.brief,
        company: this.activeCompany.id,
        assigneeUserIds: this.brief.assignees
          .filter(a => a.user)
          .map(u => u.user.id),
        assigneeAppLicenseGroupIds: this.brief.assignees
          .filter(a => a.appLicenseGroup)
          .map(g => g.appLicenseGroup)
      };
      this.loading = true;
      this.createBrief({ data: newBriefData })
        .then(data => {
          this.$notify({
            title: "Success",
            message: "Brief successfully created",
            type: "success"
          });
          if (this.createAnother) {
            this.brief = getInitialBriefData();
            this.$refs.form.$refs.scheduler.resetPickerValue();
            this.mainPane.scroll({ to: "top" });
          } else {
            this.$router.push({
              name: "briefEdit",
              params: { briefId: data.id }
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$notify({
            title: "Error",
            message: "Oops, something went wrong",
            type: "error"
          });
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
